// extracted by mini-css-extract-plugin
module.exports = {"padding-md":"padding-md__22Nrk","message-modal-action":"message-modal-action__2qZRs"};